import { useEffect, useState } from 'react';
import { getApiLanguage, VISIME_LANGUAGE_CHANGED, VISIME_UI_LANGUAGE_KEY } from '../../config/apiLanguage';
import { replaceLangInUrl } from '../../marketing/marketingLangUrl';
import { useT } from '../../i18n/useT';

const LANGUAGES = [
  { code: 'en' as const, label: 'EN' },
  { code: 'de' as const, label: 'DE' },
];

export default function MarketingLanguageToggle() {
  const t = useT();
  const [lang, setLang] = useState<'en' | 'de'>(getApiLanguage() === 'de' ? 'de' : 'en');

  useEffect(() => {
    const onLang = () => setLang(getApiLanguage() === 'de' ? 'de' : 'en');
    window.addEventListener(VISIME_LANGUAGE_CHANGED, onLang);
    return () => window.removeEventListener(VISIME_LANGUAGE_CHANGED, onLang);
  }, []);

  const setLanguage = (code: 'en' | 'de') => {
    localStorage.setItem(VISIME_UI_LANGUAGE_KEY, code);
    replaceLangInUrl(code);
    window.dispatchEvent(new Event(VISIME_LANGUAGE_CHANGED));
    setLang(code);
  };

  return (
    <div className="wl-lang" role="group" aria-label={t('languageAria')}>
      {LANGUAGES.map(({ code, label }) => {
        const active = lang === code;
        return (
          <button
            key={code}
            type="button"
            className={`wl-lang-btn${active ? ' is-active' : ''}`}
            aria-pressed={active}
            onClick={() => setLanguage(code)}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
